import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import CityDropdown from './cityDropdown';
import PartnersList from './partnersList';
import FooterNav from './footerNav';
import { updateCity, updateRegion } from '../../../../actions';
import { getPatientInfo } from '../../../../actions/patientsActions';
import AppsList from './apps';
import { isMobile } from '../../../../utils/mobile';
import Auth from '../../../../containers/Auth';

// Import icons for mobile menu
import homeIcon from '../../../../assets/img/recipes.svg';
import userIcon from '../../../../assets/img/user.svg';
import appointmentsIcon from '../../../../assets/img/appointments.svg';
import medicamentsIcon from '../../../../assets/img/medicaments.svg';
import recipesIcon from '../../../../assets/img/medical-history.svg';

const currentYear = new Date().getFullYear();

const Footer = ({ updateCity, updateRegion, history, user, page, patient, getPatientInfo }) => {
  const [isMobileView, setIsMobileView] = useState(isMobile());
  const [currentPath, setCurrentPath] = useState(history?.location?.pathname || '/');
  const [authIsOpen, setAuthIsOpen] = useState(false);
  const [isDevDisabled, setIsDevDisabled] = useState(() => localStorage.getItem('ednipro_popup_dev_disabled') === 'true');

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(isMobile());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!history || !history.listen) return;
    
    const unlisten = history.listen((location) => {
      if (location && location.pathname) {
        setCurrentPath(location.pathname);
      }
    });
    
    return unlisten;
  }, [history]);

  // Initialize patient data when user is authenticated and patient data is empty
  useEffect(() => {
    
    if (user?.token && patient?.data?.id  === undefined && !patient?.loading) {
      // Check if there's a selected patient ID in localStorage
      const savedPatientId = localStorage.getItem('patientId');
      
      if (savedPatientId) {
        // If we have a saved patient ID, load that specific patient
        getPatientInfo(savedPatientId);
      }
      // If no saved patient ID, don't load anything - user will need to select manually
    }
  }, [user?.token, patient, getPatientInfo]);

  const onCityChange = (city) => {
    updateCity(city);

    if (history && history.push) {
      history.push('/');
    }
  };

  const onRegionChange = (region) => {
    updateRegion(region);

    if (history && history.push) {
      history.push('/');
    }
  };

  const handleMobileNavClick = (path) => {
    if (history && history.push) {
      history.push(path);
    }
  };

  const handleAuthRequiredClick = (path) => {
    if (!user?.token) {
      // If user is not authorized, open auth modal
      if (path === '/office') {
        setAuthIsOpen(true);
      }
      // For other protected routes, do nothing (they are disabled)
      return;
    }
    if(patient?.data?.id === 0 || patient?.data?.id === undefined) {
      if(path === '/office/recipes' || path === '/office/service-requests') {
        return;
      }
    }
    if(patient?.data?.id === undefined && path === '/office/appointments') {
      return;
    }
    // If user is authorized, navigate normally
    handleMobileNavClick(path);
  };

  const isActiveRoute = (path, eq) => {
    if (path === '/') {
      return currentPath === '/';
    }
    if (eq) {
      return currentPath === path;
    }
    return currentPath.startsWith(path);
  };
  const isApp = !!window.ReactNativeWebView;
  const hide_footer = isApp ? user?.edniproPopup?.app_hide_footer : user?.edniproPopup?.web_hide_footer;
  

  if(hide_footer && user?.city?.id === 1 && !isDevDisabled) {
    return (<></>);
  }
  // Mobile footer menu
  if (isMobileView) {
    const isAuthorized = user?.token;
    
    return (
      <>
        <footer className="footer-mobile">
          <div className="mobile-nav">
            <div 
              className={`mobile-nav-item ${isActiveRoute('/') ? 'active' : ''}`} 
              onClick={() => handleMobileNavClick('/')}
            >
              <img src={homeIcon} alt="Головна" className="mobile-nav-icon" />
              <span className="mobile-nav-label">Лікарі</span>
            </div>
            <div 
              className={`mobile-nav-item ${isActiveRoute('/office', true) ? 'active' : ''}`} 
              onClick={() => handleAuthRequiredClick('/office')}
            >
              <img src={userIcon} alt="Кабінет" className="mobile-nav-icon" />
              <span className="mobile-nav-label">Кабінет</span>
            </div>
            <div 
              className={`mobile-nav-item ${isActiveRoute('/office/appointments') ? 'active' : ''} ${!isAuthorized || patient?.data?.id === undefined ? 'disabled' : ''}`} 
              onClick={() => handleAuthRequiredClick('/office/appointments')}
            >
              <img src={appointmentsIcon} alt="Записи" className="mobile-nav-icon" />
              <span className="mobile-nav-label">Записи</span>
            </div>
            <div 
              className={`mobile-nav-item ${isActiveRoute('/office/recipes') ? 'active' : ''} ${!isAuthorized || patient?.data?.id === 0 || patient?.data?.id === undefined ? 'disabled' : ''}`} 
              onClick={() => handleAuthRequiredClick('/office/recipes')}
            >
              <img src={medicamentsIcon} alt="Призначення" className="mobile-nav-icon" />
              <span className="mobile-nav-label">Призначення</span>
            </div>
            <div 
              className={`mobile-nav-item ${isActiveRoute('/office/service-requests') ? 'active' : ''} ${!isAuthorized || patient?.data?.id === 0 || patient?.data?.id === undefined ? 'disabled' : ''}`} 
              onClick={() => handleAuthRequiredClick('/office/service-requests')}
            >
              <img src={recipesIcon} alt="Направлення" className="mobile-nav-icon" />
              <span className="mobile-nav-label">Направлення</span>
            </div>
          </div>
        </footer>
        
        {authIsOpen && <Auth isOpen onClose={() => setAuthIsOpen(false)} />}
      </>
    );
  }

  // Desktop footer
  return (
    <footer className="footer">
      <Container>
        
        {page !== "paid" && (<CityDropdown cities={user.cities} regions={user.regions} onChange={onCityChange} onRegionChange={onRegionChange} currentCity={user.city} currentRegion={user.region} />)}

        <FooterNav />

        <AppsList />
      </Container>
      <Container className="copyright-container">
        <div className="copyright">© 2019-{currentYear} ТОВ &quot;СІЕТ Холдінг&quot;</div>
        <PartnersList />
      </Container>
      <div className="service-status">
        «Лікарі 24/7» — пацієнтський вебсервіс, технологічно та функціонально пов’язаний з МІС
        «Каштан». Оператор МІС «Каштан»: ТОВ «СІЕТ ХОЛДІНГ», код ЄДРПОУ 39197392.
      </div>
    </footer>
  );
};

const mapStateToProps = ({ user, patients, patient }) => ({ user, patients, patient });

const mapDispatchToProps = { updateCity, updateRegion, getPatientInfo };

const enhance = compose(connect(mapStateToProps, mapDispatchToProps), withRouter);

export default enhance(Footer);
